module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.mappedCompanies,
      "label": _vm.$lang.labels.company,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.license.companyId),
      callback: function($$v) {
        _vm.$set(_vm.license, "companyId", $$v)
      },
      expression: "license.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.licenseTypes,
      "label": _vm.$lang.header.licenseType,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLicenseType)); }]
    },
    model: {
      value: (_vm.license.licenseType),
      callback: function($$v) {
        _vm.$set(_vm.license, "licenseType", $$v)
      },
      expression: "license.licenseType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "readonly": _vm.isView || _vm.testLicense,
      "label": _vm.$lang.labels.concurrent,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingConcurrent)); }]
    },
    model: {
      value: (_vm.license.licenseAttributes.concurrentUsers),
      callback: function($$v) {
        _vm.$set(_vm.license.licenseAttributes, "concurrentUsers", $$v)
      },
      expression: "license.licenseAttributes.concurrentUsers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.sunLicense,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingSunLicense)); }]
    },
    model: {
      value: (_vm.license.sunLicenseSystemVersion),
      callback: function($$v) {
        _vm.$set(_vm.license, "sunLicenseSystemVersion", $$v)
      },
      expression: "license.sunLicenseSystemVersion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "clearable": "",
      "readonly": _vm.isView,
      "items": _vm.instances,
      "label": _vm.$lang.header.moonInstName,
      "item-text": "name",
      "item-value": "instanceId"
    },
    model: {
      value: (_vm.license.moonInstanceId),
      callback: function($$v) {
        _vm.$set(_vm.license, "moonInstanceId", $$v)
      },
      expression: "license.moonInstanceId"
    }
  })], 1), _vm._v(" "), (_vm.isView) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.licenseSyncStatus
    },
    model: {
      value: (_vm.license.licenseSyncStatus),
      callback: function($$v) {
        _vm.$set(_vm.license, "licenseSyncStatus", $$v)
      },
      expression: "license.licenseSyncStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isView) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.moonInstID,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.license.moonInstanceId),
      callback: function($$v) {
        _vm.$set(_vm.license, "moonInstanceId", $$v)
      },
      expression: "license.moonInstanceId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.license.getsActiveOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px",
      "disabled": _vm.isView
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.license, "getsActiveOn", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.license, "getsActiveOn", $event)
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "readonly": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingActivationDate)); }],
      "label": _vm.$lang.header.activationDate,
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.license.getsActiveOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "getsActiveOn", $$v)
      },
      expression: "license.getsActiveOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.license.getsActiveOn)
      }
    },
    model: {
      value: (_vm.license.getsActiveOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "getsActiveOn", $$v)
      },
      expression: "license.getsActiveOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.license.expiresOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px",
      "disabled": _vm.isView || _vm.testLicense
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.license, "expiresOn", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.license, "expiresOn", $event)
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingExpiryDate)); }],
      "readonly": "",
      "label": _vm.$lang.header.expiryDate,
      "prepend-icon": "event",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.license.expiresOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "expiresOn", $$v)
      },
      expression: "license.expiresOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.license.expiresOn)
      }
    },
    model: {
      value: (_vm.license.expiresOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "expiresOn", $$v)
      },
      expression: "license.expiresOn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(_vm.isView && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(_vm.isView && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'licenses'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), (_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        _vm.viewMiniLicense = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.viewMiniLicense))]) : _c('v-btn', {
    staticClass: "primary mx-2",
    attrs: {
      "disabled": !_vm.valid || _vm.creating
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.create))])], 1)], 1)], 1), _vm._v(" "), (_vm.viewMiniLicense) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.viewMiniLicense),
      callback: function($$v) {
        _vm.viewMiniLicense = $$v
      },
      expression: "viewMiniLicense"
    }
  }, [_c('mini-license-modal', {
    attrs: {
      "license": _vm.license
    },
    on: {
      "close": function($event) {
        _vm.viewMiniLicense = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "licenseId": _vm.activationData
    },
    on: {
      "close": function($event) {
        _vm.showActivationModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c63551c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/licenses/LicenseDetails.vue
// module id = 434
// module chunks = 35